import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useLocale } from '@/i18n/useLocale'
import { useConsent } from '@/analytics/consentContext'
import { localePath, ROUTES } from '@/lib/routes'
import { SOFT_LAUNCH } from '@/lib/launchMode'
import { LanguageSwitcher } from './LanguageSwitcher'

const PLAYGROUND_DOCS_URL = 'https://ode-playground.fly.dev/docs'

export function Footer() {
  const { t } = useTranslation()
  const locale = useLocale()
  const { resetChoice } = useConsent()

  return (
    <footer className="border-t border-mono-300 dark:border-mono-800 mt-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-base">
        <div>
          <div className="font-bold tracking-wider text-base mb-1">{t('site.name')}</div>
          <div className="opacity-60">{t('site.tagline')}</div>
        </div>
        <div>
          <div className="font-semibold mb-2">{t('footer.product')}</div>
          <ul className="space-y-1.5 opacity-75 -ml-5">
            <li>
              <a href="#features" className="marker-dot inline-block">{t('nav.features')}</a>
            </li>
            {!SOFT_LAUNCH && (
              <>
                <li>
                  <Link to={localePath(locale, ROUTES.news)} className="marker-dot inline-block">{t('nav.news')}</Link>
                </li>
                <li>
                  <a href={PLAYGROUND_DOCS_URL} target="_blank" rel="noreferrer" className="marker-dot inline-block">
                    {t('nav.docs')} ↗
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-2">{t('footer.legal')}</div>
          <ul className="space-y-1.5 opacity-75 -ml-5">
            <li>
              <Link to={localePath(locale, ROUTES.privacy)} className="marker-dot inline-block">{t('footer.privacy')}</Link>
            </li>
            <li>
              <Link to={localePath(locale, ROUTES.terms)} className="marker-dot inline-block">{t('footer.terms')}</Link>
            </li>
            <li>
              <button onClick={resetChoice} className="marker-dot underline">
                {t('footer.preferences')}
              </button>
            </li>
          </ul>
        </div>
        <div>
          <LanguageSwitcher />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8 pb-8">
        <div className="pt-4 border-t border-mono-300/30 dark:border-mono-700/30 text-2xs opacity-60 text-center">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </div>
      </div>
    </footer>
  )
}
